import { InvoiceModel, UpdateInvoicePayload } from "@jugl-web/rest-api";
import { useTranslations } from "@jugl-web/utils";
import { useEntitySelectedProvider } from "@web-src/modules/entities/providers/EntityProvider/useEntitySelectedProvider";
import { invoicesApi } from "@web-src/modules/api/createApi";

export const useUpdateInvoice = () => {
  const { t } = useTranslations();
  const { entityId } = useEntitySelectedProvider();
  const [updateInvoiceMutation] = invoicesApi.useUpdateInvoiceMutation();

  return async (
    invoiceId: string,
    payload: Partial<UpdateInvoicePayload>
  ): Promise<InvoiceModel> =>
    updateInvoiceMutation({
      entityId,
      invoiceId,
      payload,
      meta: {
        successMessage: t({
          defaultMessage: "Invoice updated successfully",
          id: "invoices.invoice-updated-successfully",
        }),
        getErrorMessage: () =>
          t({
            defaultMessage: "Failed to update invoice",
            id: "invoices.invoice-update-failed",
          }),
      },
    }).unwrap();
};
